module.exports = __webpack_public_path__ + "static/media/sampleIncludeExclude.fa71a873.csv";